import { observer } from 'mobx-react-lite'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Preloader, DateRange } from 'shared/components'
import { CommonPage } from 'shared/layout'
import { MembershipReportFeature } from 'features/report/membership'
import { ReferrersReportViewModel } from './referrers-report.view-model'
import { ReferrersReportFeature } from '../../../../features/report/referrers'

export const ReferrersReportPage = observer(() => {
  const [date, setDate] = useState(moment())
  const [dateTo, setDateTo] = useState(moment())

  const from = date.startOf('month').toISOString()
  const to = dateTo.endOf('month').toISOString()

  useEffect(() => {
    ReferrersReportViewModel.init(from, to)
  }, [from, to])

  return ReferrersReportViewModel.loading ? (
    <Preloader message="Loading Sales Report" lower />
  ) : (
    <CommonPage
      title={
        <h2>Sales report</h2>
      }
      actions={
        <DateRange
          type="month"
          defaultValue={[date, dateTo]}
          onChange={(from: any, to: any) => {
            setDate(from)
            setDateTo(to)
          }}
        />
      }
      isMounted={!ReferrersReportViewModel.loading}
    >
      <ReferrersReportFeature />
    </CommonPage>
  )
})
